import { page as pageIndex, globals } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import { logOut } from './auth'
import { clearHistory, saveInitialValues } from './undo'
import { showModal, hideModal } from './modal'
import { returnRegions } from './regions'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_QUERIES_AND_PARAMETERS_START = 'GET_QUERIES_AND_PARAMETERS_START'
export const GET_QUERIES_AND_PARAMETERS_FETCHED = 'GET_QUERIES_AND_PARAMETERS_FETCHED'
export const GET_QUERIES_AND_PARAMETERS_FAILURE = 'GET_QUERIES_AND_PARAMETERS_FAILURE'
export const GET_REGS_URLS_START = 'GET_REGS_URLS_START'
export const GET_REGS_URLS_FETCHED = 'GET_REGS_URLS_FETCHED'
export const GET_REGS_URLS_FAILURE = 'GET_REGS_URLS_FAILURE'
export const GET_REGS_URL_START = 'GET_REGS_URL_START'
export const GET_REGS_URL_FETCHED = 'GET_REGS_URL_FETCHED'
export const GET_REGS_URL_FAILURE = 'GET_REGS_URL_FAILURE'
export const SAVE_REGS_URL_START = 'SAVE_REGS_URL_START'
export const REGS_URL_SAVED = 'REGS_URL_SAVED'
export const SAVE_REGS_URL_FAILURE = 'SAVE_REGS_URL_FAILURE'
export const RETURN_INITIAL_REGS_URLS = 'RETURN_INITIAL_REGS_URLS'
export const GET_REGS_URL_ENTITY_START = 'GET_REGS_URL_ENTITY_START'
export const REGS_URL_ENTITY_FETCHED = 'REGS_URL_ENTITY_FETCHED'
export const GET_REGS_URL_ENTITY_FAILURE = 'GET_REGS_URL_ENTITY_FAILURE'
export const CLEAR_REGS_URL_FORM = 'CLEAR_REGS_URL_FORM'
export const CREATE_REGS_URL_START = 'CREATE_REGS_URL_START'
export const REGS_URL_CREATED = 'REGS_URL_CREATED'
export const CREATE_REGS_URL_FAILURE = 'CREATE_REGS_URL_FAILURE'
export const UPDATE_REGS_URL_START = 'UPDATE_REGS_URL_START'
export const REGS_URL_UPDATED = 'REGS_URL_UPDATED'
export const UPDATE_REGS_URL_FAILURE = 'UPDATE_REGS_URL_FAILURE'
export const DELETE_REGS_URL_START = 'DELETE_REGS_URL_START'
export const REGS_URL_DELETED = 'REGS_URL_DELETED'
export const DELETE_REGS_URL_FAILURE = 'DELETE_REGS_URL_FAILURE'
export const REGS_URL_EXISTS = 'REGS_URL_EXISTS'
export const GET_SET_OPTIONS_START = 'GET_SET_OPTIONS_START'
export const SET_OPTIONS_FETCHED = 'SET_OPTIONS_FETCHED'
export const GET_SET_OPTIONS_FAILURE = 'GET_SET_OPTIONS_FAILURE'
export const CLEAR_FIELD_FOR_NO_RESULTS_RU = 'CLEAR_FIELD_FOR_NO_RESULTS_RU'
export const SAVE_REGS_URL_FEEDBACK_START = 'SAVE_REGS_URL_FEEDBACK_START'
export const SAVE_REGS_URL_FEEDBACK_SUCCESS = 'SAVE_REGS_URL_FEEDBACK_SUCCESS'
export const SAVE_REGS_URL_FEEDBACK_FAILURE = 'SAVE_REGS_URL_FEEDBACK_FAILURE'

// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function getQueriesWithParameters () {
  return (dispatch) => {
    dispatch({ type: GET_QUERIES_AND_PARAMETERS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/RegsUrls`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_QUERIES_AND_PARAMETERS_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_QUERIES_AND_PARAMETERS_FAILURE })
    })
  }
}

export function getRegsUrls (regsUrlsParameters, queryId, openRecordId) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_URLS_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(regsUrlsParameters)
    }
    fetch(`${globals.apiUrl}/RegsUrls`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_REGS_URLS_FETCHED,
          payload: {
            json
          }
        })
        if (json.length === 0) {
          dispatch(showModal('No-results'))
        } else if (openRecordId) {
          dispatch(getRegsUrlData(openRecordId, queryId))
        } else {
          dispatch(getRegsUrlData(json[0].Id, queryId))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_REGS_URLS_FAILURE })
    })
  }
}

export function getRegsUrlData (id, queryId) {
  return (dispatch, getState) => {
    dispatch({ type: GET_REGS_URL_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/RegsUrlReview/${id}?queryId=${queryId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_REGS_URL_FETCHED,
          payload: {
            json
          }
        })
        dispatch(
          saveInitialValues(
            pageIndex.regsUrls,
            getState().regsUrls.formDataValue.RU
          )
        );
        dispatch(clearHistory(pageIndex.regsUrls));
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_REGS_URL_FAILURE })
    })
  }
}

export function sendRegUrlFeedback (feedback, feedbackNote, RegsURLsId) {
  return (dispatch) => {
    dispatch({ type: SAVE_REGS_URL_FEEDBACK_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify({ Feedback: feedback, FeedbackNote: feedbackNote, Id: parseInt(RegsURLsId, 10) })
    }
    fetch(`${globals.apiUrl}/RegsUrlFeedback`, options)
    .then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    })
    .then((json) => {
      if (json) {
        dispatch({
          type: SAVE_REGS_URL_FEEDBACK_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SAVE_REGS_URL_FEEDBACK_FAILURE })
    })
  }
}

export function saveRegsUrlData (regsUrlDetail, queryId, trackData, openRecord) {
  return (dispatch) => {
    dispatch({ type: SAVE_REGS_URL_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(regsUrlDetail)
    }
    fetch(`${globals.apiUrl}/RegsUrlReview?queryId=${queryId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REGS_URL_SAVED,
          payload: {
            json
          }
        })
        if (localStorage.getItem('signOut')) {
          dispatch(logOut())
          localStorage.removeItem('signOut')
        }
        dispatch(clearHistory(pageIndex.regsUrls))
        dispatch(saveInitialValues(pageIndex.regsUrls, trackData))
        if (openRecord) {
          dispatch(getRegsUrlData(openRecord, queryId))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SAVE_REGS_URL_FAILURE })
    })
  }
}

export function bringEditedRegsUrlItem (id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_URL_ENTITY_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/RegsUrl/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REGS_URL_ENTITY_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_REGS_URL_ENTITY_FAILURE })
    })
  }
}

export function createRegsUrl (regsUrlSummary, queryId) {
  return (dispatch) => {
    dispatch({ type: CREATE_REGS_URL_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(regsUrlSummary)
    }
    fetch(`${globals.apiUrl}/RegsUrl`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 409) {
        response.json().then((json) => {
          if (json) {
            dispatch({
              type: REGS_URL_EXISTS,
              payload: {
                json
              }
            })
            dispatch(hideModal('Add-new-item-url'))
            dispatch(hideModal('List-url'))
            dispatch(showModal('Duplicate-modal'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REGS_URL_CREATED,
          payload: {
            json
          }
        })
        dispatch(hideModal('Add-new-item-url'))
        dispatch(hideModal('List-url'))
        dispatch(getRegsUrlData (json.Id, queryId))
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_REGS_URL_FAILURE })
    })
  }
}

export function updateRegsUrl (regsUrlSummary, queryId) {
  return (dispatch) => {
    dispatch({ type: UPDATE_REGS_URL_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(regsUrlSummary)
    }
    fetch(`${globals.apiUrl}/RegsUrl`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REGS_URL_UPDATED,
          payload: {
            json
          }
        })
        if (queryId) {
          dispatch(getRegsUrlData(json.Id, queryId))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_REGS_URL_FAILURE })
    })
  }
}

export function deleteRegsUrl (id, queryId, allRecords) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_URL_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/RegsUrl/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.text()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then(() => {
        const allUrls = allRecords.filter(item => item.Id !== id)
        dispatch({
          type: REGS_URL_DELETED,
          payload: {
            id,
            allRecords: allUrls
          }
        })
        if (queryId) {
          dispatch(getRegsUrlData(allUrls[0].Id, queryId))
        }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_REGS_URL_FAILURE })
    })
  }
}

export function getSetOptions () {
  return (dispatch) => {
    dispatch({ type: GET_SET_OPTIONS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/RegsUrlSet`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SET_OPTIONS_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_SET_OPTIONS_FAILURE })
    })
  }
}

function returnDropdownOptions (data, field) {
  let resultedOptions = []
  data.map(item => {
    if (!resultedOptions.find(elem => elem.label === item[field])) {
      resultedOptions = [...resultedOptions, {
        value: item[field],
        label: item[field]
      }]
    }
  })
  return resultedOptions
}

export function returnInitialState () {
  return {
    type: RETURN_INITIAL_REGS_URLS
  }
}

export function clearEditUrlForm () {
  return {
    type: CLEAR_REGS_URL_FORM
  }
}

function updateStates (data, allRegions) {
  const recordStates = returnDropdownOptions(data, 'RegionShortName')
  const transformStates = allRegions.map(item => {
    const checkAllRegions = recordStates.find(el => el.value === item.value)
    if (checkAllRegions) {
      return item
    } else return null
  }).filter(elem => elem)
  return [...transformStates]
}

export function clearFormFields () {
  return {
    type: CLEAR_FIELD_FOR_NO_RESULTS_RU
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.regsUrls
    ? state : actionHandler(state, action),
  [GET_QUERIES_AND_PARAMETERS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map(item => {
          return {
            value: item.QueryId,
            label: item.QueryName
          }
        })
      }
    }
  },
  'FILTER_REGIONS' : (state, action) => {
    const { country, page } = action.payload
    if (page !== 'RU') {
      return {
        ...state
      }
    } else {
      const checkRecords = state.renderData.allRecords.filter(item => item.Country === country)
      const checkState = state.renderData.allRecords.filter(el =>
        el.Country === state.formDataValue.RU.baseData.radio.country)
      return {
        ...state,
        renderData: {
          ...state.renderData,
          amountOfRecords: country === 'all' ? state.renderData.allRecords : checkRecords
        },
        formDataValue: {
          RU: checkRecords.length !== 0 ? {
            ...state.formDataValue.RU,
            baseData: {
              ...state.formDataValue.RU.baseData,
              state: checkState[0].RegionShortName
            }
          } : {
            ...state.formDataValue.RU,
            queryLine: { ...state.formDataValue.RU.queryLine },
            baseData: {
              ...state.formDataValue.RU.baseData,
              radio: {
                ...state.formDataValue.RU.baseData.radio,
                country: 'all',
                state: 'all'
              }
            }
          }
        }
      }
    }
  },
  'GET_ALL_REGIONS_FETCHED' : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRegions: returnRegions(json),
        regionsList: returnRegions(json),
        regions: json
      }
    }
  },
  [GET_REGS_URLS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_REGS_URLS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      disableEditing: json.length === 0,
      renderData: {
        ...state.renderData,
        amountOfRecords: json,
        allRecords: json,
        agencies: returnDropdownOptions(json, 'Agency'),
        allRegions: json.length === 0 ? state.renderData.allRegions : updateStates(json, state.renderData.regionsList)
      }
    }
  },
  [GET_REGS_URLS_FAILURE] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [GET_REGS_URL_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_REGS_URL_FETCHED] : (state, action) => {
    const { json } = action.payload
    const checkRecordExistance = state.renderData.amountOfRecords.find(item => item.Id === json.Id)
    let recordPosition
    let allRecords = state.renderData.allRecords
    if (checkRecordExistance) {
      recordPosition = state.renderData.amountOfRecords.findIndex(item => item.Id === json.Id)
    } else {
      recordPosition = allRecords.findIndex(item => item.RegionShortName === json.RegionShortName)
      allRecords.splice(recordPosition, 0, json)
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        regsUrlData: json,
        allRecords: allRecords,
        amountOfRecords: allRecords
      },
      formDataValue: {
        RU: {
          ...state.formDataValue.RU,
          navigation: {
            textValues: {
              currentRecord: recordPosition + 1
            }
          },
          radio: {
            ...state.formDataValue.RU.radio,
            agency: json.Agency,
            country: json.Country,
            state: json.RegionShortName, 
            comparisonType: json.RegsUrlsReviewType, 
            reviewService: json.ReviewService,
            compareLinkUrls: json.CompareLinkUrls, 
            saveVersions: json.SaveVersions, 
          },
          textValues: {
            url: json.Url,
            id: json.Id,
            document: json.Document, 
            compareUser: json.CompareUser, 
            selector: json.Selector,
          },
          baseData: {
            radio: {
              ...state.formDataValue.RU.baseData.radio,
              agency: json.Agency,
              country: json.Country,
              state: json.RegionShortName, 
              comparisonType: json.RegsUrlsReviewType, 
              reviewService: json.ReviewService,
              compareLinkUrls: json.CompareLinkUrls, 
              saveVersions: json.SaveVersions, 
            },
            textValues: {
              ...state.formDataValue.RU.baseData.textValues,
              url: json.Url,
              id: json.Id,
              document: json.Document, 
              compareUser: json.CompareUser, 
              selector: json.Selector,
            }
          },
          textBlocks: {
            textValues: {
              log: json.HistoryDetails || ''
            }
          },
          notesSetData: {
            textValues: {
              ...state.formDataValue.RU.notesSetData.textValues,
              contactInfo: json.OfficialContact || '',
              reviewNotes: json.Notes || '',
              reviewInstructions: json.ReviewInstructions || '',
              clients: json.Clients || ''
            },
          },
          visualPingData: {
            regsurlsvisualpingid: json.VisualPing ? json.VisualPing.RegsUrlsVisualPingId : null,
            regsurlsid: json.VisualPing ? json.VisualPing.RegsUrlsId : null,
            active: json.VisualPing ? json.VisualPing.Active : false,
            jobid: json.VisualPing ? json.VisualPing.JobId : null,
            visualpingid: json.VisualPing ? json.VisualPing.VisualPingId : null,
            url: json.VisualPing ? json.VisualPing.Url : null,
            createdate: json.VisualPing ? json.VisualPing.CreateDate : null,
            lastupdatedate: json.VisualPing ? json.VisualPing.LastUpdateDate : null,
            changediffs: json.VisualPing ? json.VisualPing.ChangeDiffs : [],
          }
        }
      }
    }
  },
  [GET_REGS_URL_FAILURE] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [RETURN_INITIAL_REGS_URLS] : () => {
    return {
      ...initialState
    }
  },
  [REGS_URL_ENTITY_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      formDataValue: {
        RU: {
          ...state.formDataValue.RU,
          editUrlData: {
            radio: {
              set: json.Set,
              state: json.RegionShortName,
              country: json.Country
            },
            textValues: {
              agency: json.Agency,
              document: json.Document,
              url: json.Url
            }
          }
        }
      }
    }
  },
  [CLEAR_REGS_URL_FORM] : (state) => {
    return {
      ...state,
      formDataValue: {
        RU: {
          ...state.formDataValue.RU,
          editUrlData: {
            radio: {
              set: '',
              state: '',
              country: ''
            },
            textValues: {
              agency: '',
              document: '',
              url: ''
            }
          }
        }
      }
    }
  },
  [REGS_URL_CREATED] : (state, action) => {
    const { json } = action.payload
    let allRecords = state.renderData.allRecords
    const insertIndex = allRecords.findIndex(item => item.RegionShortName === json.RegionShortName)
    allRecords.splice(insertIndex, 0, json)
    const checkStateExistance = state.renderData.allRegions.find(item => item.value === json.RegionShortName)
    let allRegions = state.renderData.allRegions
    if (!checkStateExistance) {
      allRegions = updateStates(allRecords, state.renderData.allRegions)
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRecords: allRecords,
        amountOfRecords: allRecords,
        agencies: returnDropdownOptions(allRecords, 'Agency'),
        allRegions: allRegions,
        newRegUrl: true
      }
    }
  },
  [REGS_URL_UPDATED] : (state, action) => {
    const { json } = action.payload
    const allRecords = state.renderData.allRecords
    const updatedRecords = allRecords.map(item => {
      if (item.Id === json.Id) {
        return {
          Agency: json.Agency,
          Country: json.Country,
          Document: json.Document,
          Id: item.Id,
          RegionShortName: json.RegionShortName,
          Set:json.Set
        }
      } return item
    })
    const checkStateExistance = allRecords.find(item => item.value === json.RegionShortName)
    let allRegions = state.renderData.allRegions
    if (!checkStateExistance) {
      allRegions = updateStates(updatedRecords, allRegions)
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRecords: updatedRecords,
        amountOfRecords: updatedRecords,
        agencies: returnDropdownOptions(updatedRecords, 'Agency'),
        allRegions: allRegions,
        newRegUrl: false
      }
    }
  },
  [REGS_URL_DELETED] : (state, action) => {
    const { id, allRecords } = action.payload
    const deletedAgency = state.renderData.allRecords.find(item => item.Id === id)
    const checkAgencyExistance = state.renderData.allRegions.filter(item =>
      item.Agency === deletedAgency.Agency)
    let newAgenciesList = state.renderData.agencies
    if (checkAgencyExistance.length === 1 && id === checkAgencyExistance[0].Id) {
      newAgenciesList = state.renderData.agencies.filter(item => item.label !== deletedAgency.Agency)
    }
    const findIndex = allRecords.findIndex(item => item.Id === state.renderData.regsUrlData.Id)
    const checkStateExistance = state.renderData.allRegions.filter(item =>
      item.RegionShortName === deletedAgency.RegionShortName)
    let allRegions = state.renderData.allRegions
    if (checkStateExistance.length === 1 && id === checkStateExistance[0].Id) {
      allRegions = allRecords.filter(item => item.RegionShortName !== deletedAgency.RegionShortName)
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRecords: allRecords,
        amountOfRecords: allRecords,
        agencies: newAgenciesList,
        allRegions: allRegions
      },
      formDataValue: {
        RU: {
          ...state.formDataValue.RU,
          navigation: {
            textValues: {
              currentRecord: findIndex + 1
            }
          }
        }
      }
    }
  },
  [REGS_URL_EXISTS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedRegsUrl: json
      }
    }
  },
  [SET_OPTIONS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        sets: returnDropdownOptions(json, 'SetName')
      }
    }
  },
  [REGS_URL_SAVED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        regsUrlData: json,
        newRegUrl: false
      }
    }
  },
  [CLEAR_FIELD_FOR_NO_RESULTS_RU] : (state) => {
    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList
      },
      formDataValue: {
        RU: {
          ...initialState.formDataValue.RU,
          queryLine: {
            ...state.formDataValue.RU.queryLine
          },
          parametersSection: {
            ...state.formDataValue.RU.parametersSection
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  disableEditing: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    RU: {
      queryLine: {
        radio: {
          query: 'Select Query'
        },
        textValues: {
          keywordSearch: ''
        },
        selected: []
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },

      // parametersSection: {
      //   textValues: {},
      //   dateTime: {}
      // },
      // navigation: {
      //   textValues: {
      //     currentRecord: '1'
      //   }
      // },
      baseData: {
        radio: {
          state: '',
          country: '',
          agency: '', 
          comparisonType: '', 
          compareLinkUrls: false, 
          reviewService: '',
          saveVersions: 0, 
        },
        textValues: {
          url: '',
          id: '',
          document: '',
          compareUser: '',
          selector: '',
        }
      },
      textBlocks: {
        textValues: {
          log: ''
        }
      },
      notesSetData: {
        textValues: {
          contactInfo: '',
          reviewNotes: '',
          reviewInstructions: '',
          clients: '',
          // compareUser: '',
          // selector: '',
        },
      },
      editUrlData: {
        radio: {
          set: '',
          state: '',
          country: ''
        },
        textValues: {
          agency: '',
          document: '',
          url: ''
        }
      },
      visualPingData: {
        regsurlsvisualpingid: '',
        regsurlsid: '',
        active: false,
        jobid: '',
        visualpingid: '',
        url: '',
        createdate: '',
        lastupdatedate: '',
        changediffs: [],
      }
    }
  }
}
export default function regsUrlReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/regsUrls.js